// extracted by mini-css-extract-plugin
module.exports = {"fontInput":"fontInput_fontInput__1UkiF","fontInputHorizontal":"fontInput_fontInputHorizontal__MQMDL","fontInputHorizontalGroup":"fontInput_fontInputHorizontalGroup__cqoZs"};